/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

const getters = {
  getCountries(state) {
    return state.countries;
  },
  getServerMessages(state) {
    var messages = [];
    var key;
    var value;
    if (state.server_messages.length != 0) {
      for (let x = 0; x < state.server_messages.length; x++) {
        key = Object.keys(state.server_messages[x]);
        value = state.server_messages[x][key[0]];
        messages.push({ key: key[0], value: value });
      }
      return messages;
    } else {
      return [];
    }
  },

  GetTotalAmount: function (state) {
    if (state.StoredProducts.length == 0) return 0;

    var total = state.StoredProducts.reduce(function (a, b) {
      return a + (b.quantity * b.amount - b.discount * b.quantity);
    }, 0);

    return total;
  },
  GetSubTotalAmount: function (state) {
    if (state.StoredProducts.length == 0) return 0;

    var total = state.StoredProducts.reduce(function (a, b) {
      return a + b.quantity * b.amount;
    }, 0);

    return total;
  },

  GetDiscountAmount: function (state) {
    if (state.StoredProducts.length == 0) return 0;

    var total = state.StoredProducts.reduce(function (a, b) {
      return a + parseInt(b.discount) * b.quantity;
    }, 0);
    return total;
  },
};

export default getters;
